import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, RefreshCw, Headphones, ArrowRight, CheckCircle2, HelpCircle } from 'lucide-react';
import { Button } from '../ui/Button';
import { EnhancedScrollReveal } from '../common/EnhancedScrollReveal';
import { Badge } from '../ui/Badge';
import { Accordion } from '../ui/Accordion';
export function GuaranteeSection() {
  return <section className="py-24 bg-white border-t border-gray-100 overflow-hidden" data-id="element-1957">
      <div className="container-custom max-w-7xl mx-auto" data-id="element-1958">
        <div className="bg-gradient-to-br from-primary-50 via-white to-primary-50 rounded-[3rem] p-8 md:p-16 lg:p-20 border border-primary-100 relative shadow-2xl shadow-primary-900/5" data-id="element-1959">
          {/* Decorative Seal Background */}
          <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[url('https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/World_map_blank_without_borders.svg/2000px-World_map_blank_without_borders.svg.png')] opacity-5 rotate-12 pointer-events-none" data-id="element-1960" />

          <div className="grid lg:grid-cols-2 gap-16 items-center relative z-10" data-id="element-1961">
            {/* Left: Content */}
            <div className="space-y-10" data-id="element-1962">
              <EnhancedScrollReveal data-id="element-1963">
                <Badge className="mb-6 bg-white shadow-sm border-primary-100 text-primary-700" data-id="element-1964">
                  <ShieldCheck className="w-3 h-3 mr-1" data-id="element-1965" /> Garantía de Felicidad
                </Badge>
                <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-charcoal-900 mb-6 leading-tight" data-id="element-1966">
                  Pruébalo 30 días, <br data-id="element-1967" />
                  <span className="text-primary-600" data-id="element-1968">sin ningún riesgo</span>
                </h2>
                <p className="text-lg text-charcoal-600 leading-relaxed font-light" data-id="element-1969">
                  Estamos tan seguros de que verás la diferencia en la vitalidad
                  de tu mascota que asumimos todo el riesgo. Si no te encanta,
                  te devolvemos el dinero.
                </p>
              </EnhancedScrollReveal>

              <EnhancedScrollReveal delay={0.2} data-id="element-1970">
                <div className="space-y-4" data-id="element-1971">
                  {[{
                  title: 'Reembolso Íntegro',
                  desc: 'Te devolvemos el 100% del importe de tu primer pedido.'
                }, {
                  title: 'Sin Devolución Física',
                  desc: 'No hace falta que nos envíes la comida de vuelta. Dónala a un refugio.'
                }, {
                  title: 'Cancelación en 1 Clic',
                  desc: 'Sin llamadas incómodas ni procesos largos.'
                }].map((item, i) => <div key={i} className="flex items-start gap-4 p-4 rounded-2xl bg-white border border-primary-100 hover:shadow-md transition-shadow" data-id="element-1972">
                      <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 shrink-0 mt-1" data-id="element-1973">
                        <CheckCircle2 className="w-5 h-5" data-id="element-1974" />
                      </div>
                      <div data-id="element-1975">
                        <h4 className="font-bold text-charcoal-900" data-id="element-1976">
                          {item.title}
                        </h4>
                        <p className="text-sm text-charcoal-500" data-id="element-1977">{item.desc}</p>
                      </div>
                    </div>)}
                </div>
              </EnhancedScrollReveal>

              <EnhancedScrollReveal delay={0.3} data-id="element-1978">
                <Button size="xl" className="rounded-full shadow-xl shadow-primary-900/20 px-10" data-id="element-1979">
                  Empezar Prueba Sin Riesgo{' '}
                  <ArrowRight className="w-5 h-5 ml-2" data-id="element-1980" />
                </Button>
                <p className="mt-4 text-xs text-charcoal-400 font-medium" data-id="element-1981">
                  *Válido para primeros pedidos de nuevos clientes.
                </p>
              </EnhancedScrollReveal>
            </div>

            {/* Right: Seal & FAQ */}
            <div className="relative" data-id="element-1982">
              <EnhancedScrollReveal direction="left" delay={0.2} data-id="element-1983">
                <div className="bg-white rounded-[2.5rem] p-8 shadow-xl border border-gray-100 relative overflow-hidden" data-id="element-1984">
                  <div className="absolute -top-10 -right-10 w-40 h-40 bg-primary-500 text-white flex items-center justify-center transform rotate-12 shadow-lg" data-id="element-1985">
                    <div className="text-center transform -rotate-12 mt-8 mr-8" data-id="element-1986">
                      <div className="text-2xl font-bold font-serif" data-id="element-1987">100%</div>
                      <div className="text-[10px] font-bold uppercase tracking-widest" data-id="element-1988">
                        Garantizado
                      </div>
                    </div>
                  </div>

                  <h3 className="text-xl font-bold text-charcoal-900 mb-6 flex items-center gap-2" data-id="element-1989">
                    <HelpCircle className="w-5 h-5 text-primary-500" data-id="element-1990" />{' '}
                    Preguntas Frecuentes
                  </h3>

                  <div className="space-y-4" data-id="element-1991">
                    <div className="p-4 rounded-xl bg-gray-50 border border-gray-100" data-id="element-1992">
                      <h4 className="font-bold text-sm text-charcoal-900 mb-2" data-id="element-1993">
                        ¿Tengo que devolver la comida?
                      </h4>
                      <p className="text-sm text-charcoal-600" data-id="element-1994">
                        No. Por seguridad alimentaria no aceptamos devoluciones
                        de comida fresca. Te animamos a donarla a una protectora
                        local.
                      </p>
                    </div>
                    <div className="p-4 rounded-xl bg-gray-50 border border-gray-100" data-id="element-1995">
                      <h4 className="font-bold text-sm text-charcoal-900 mb-2" data-id="element-1996">
                        ¿Cuándo recibo el dinero?
                      </h4>
                      <p className="text-sm text-charcoal-600" data-id="element-1997">
                        Procesamos el reembolso en 24h tras tu solicitud.
                        Dependiendo de tu banco, puede tardar 3-5 días en
                        aparecer.
                      </p>
                    </div>
                    <div className="p-4 rounded-xl bg-gray-50 border border-gray-100" data-id="element-1998">
                      <h4 className="font-bold text-sm text-charcoal-900 mb-2" data-id="element-1999">
                        ¿Hay letra pequeña?
                      </h4>
                      <p className="text-sm text-charcoal-600" data-id="element-2000">
                        Solo una condición: la garantía aplica a tu primer
                        pedido de prueba (hasta 14 días de comida).
                      </p>
                    </div>
                  </div>
                </div>
              </EnhancedScrollReveal>
            </div>
          </div>
        </div>
      </div>
    </section>;
}